export default "__VITE_ASSET__BYCzoLT6__"